import React, { useEffect } from "react";
import sortBy from "lodash/sortBy";
import MultiSelectDD from "../multiSelectDD";
import "./FilterReport.less";
import TextFieldWithToolTip from "../TextFieldWithToolTip/TextFieldWithToolTip";
import VirtualizedAutocomplete from "../VirtualizedAutocomplete/VirtualizedAutocomplete";
import NullableSliderDatePicker from "../../common/SliderDatePicker/SliderDatePicker";
import {
  isString,
  removeDuplicates,
  reportRadioRangeQTRSlider,
  reportRadioRangeSlider,
  reportRadioRangeWeeklySlider,
  reportRadioSlider
} from "../../../utils/helper";
import moment from "moment";
import { standardDateFormat } from "../../../constants/appConstants";

export default function FilterReport({
  filterConfig = [],
  isShowFilter = true,
  onChangeFilter = () => {},
  clearFilterData = false,
  reload = false,
  allCleared = false,
  renderDownload = () => {},
  colFilteredObj = [],
  reportSectionId,
  onError=()=>{}
}) {
  const [selectedIds, setSelectedIds] = React.useState({});
  const [inputValues, setInputValues] = React.useState(null);
  const [dependentKey, setDependentKey] = React.useState(null);
  useEffect(() => {
    setSelectedIds({});
    setInputValues({});
  }, [filterConfig, clearFilterData, reload]);

  useEffect(() => {
    //setSelectedIds({ ...selectedIds, [dependentKey]: [] });
    let stateToUpdate = selectedIds;
    reportSectionId !==7 && dependentKey?.split("|")?.map(depKey => {
      stateToUpdate = {
        ...stateToUpdate,
        [depKey]: []
      };
    });
    setSelectedIds({ ...stateToUpdate });
  }, [filterConfig, allCleared]);

  /**
   * call method on every onchange of control
   * @param {*} filterKeyName -> key name
   * @param {*} value -> value of selected control
   * @param {*} filterDataType -> data type
   * @param {*} typeOfDate -> radio selection type in slider
   * @param {*} qtrSelection -> quarterly selection
   */
  function onChangeVal(
    filterKeyName,
    value,
    filterDataType = "Text",
    typeOfDate = "Monthly",
    qtrSelection = 1
  ) {
    if (filterDataType == "Text")
      setInputValues({
        ...inputValues,
        [value.id]: value.value
      });
      
   if( filterDataType == "DateRange" ||
    filterDataType == "NullableDateRange" ||
    filterDataType == "DateRangeSlider" ||
    filterDataType == "DateRangeWeeklySlider")
    {onChangeFilter(
          filterKeyName,
          (value || "").trim(),
          filterDataType,
          "",
          typeOfDate,
          qtrSelection
        );
        onError(false);
      }
      else{
        onChangeFilter(
          filterKeyName,
          (value.value || "").trim(),
          filterDataType,
          "",
          typeOfDate,
          qtrSelection
        );
      }
  }

  /**
   * call on multi selection dropdown to set multi selected value and also filter out option list of dependant filter
   * @param {*} ids -> selected Ids
   * @param {*} optionsList -> selected dropdown option list
   * @param {*} FilterKeyName -> key name
   * @param {*} FilterDataType -> data type
   * @param {*} id
   * @param {*} dependentKeyName -> dependent filter key name
   * @param {*} bit
   */
  function onMultiSelectDD(
    ids,
    optionsList,
    FilterKeyName,
    FilterDataType,
    id,
    dependentKeyName,
    bit = 0
  ) {
    let allIds = optionsList.map(function(item) {
      return item.id;
    });
    if (dependentKeyName && FilterKeyName != dependentKeyName) {
      setDependentKey(dependentKeyName);
    }
    const mIds = selectedIds[FilterKeyName] || [];

    if (ids.indexOf("All") !== -1) {
      const filteredIds = ids.filter(f => f != "All");

      if (
        filteredIds.length == allIds.length ||
        (ids.length > 0 && ids[0] == "All") ||
        (mIds.indexOf("All") == -1 && ids.indexOf("All") !== -1)
      ) {
        if (optionsList.length == 1 && ids[0] == "All") {
          allIds = [];
          setSelectedIds({ ...selectedIds, [FilterKeyName]: [] });
          onChangeFilter(
            FilterKeyName,
            allIds || [],
            FilterDataType,
            id,
            undefined,
            undefined,
            optionsList
          );
        } else {
         reportSectionId !==7 && allIds.push("All");
          setSelectedIds({ ...selectedIds, [FilterKeyName]: allIds });
          onChangeFilter(
            FilterKeyName,
            allIds || [],
            FilterDataType,
            id,
            undefined,
            undefined,
            optionsList
          );
        }
      } else {
        const idsWithoutAll = ids.filter(f => f != "All");
        setSelectedIds({ ...selectedIds, [FilterKeyName]: idsWithoutAll });
        onChangeFilter(
          FilterKeyName,
          idsWithoutAll || [],
          FilterDataType,
          id,
          undefined,
          undefined,
          optionsList
        );
      }
    } else {
      if (mIds.indexOf("All") !== -1 && bit == 0) {
        setSelectedIds({ ...selectedIds, [FilterKeyName]: [] });
        onChangeFilter(
          FilterKeyName,
          [],
          FilterDataType,
          id,
          undefined,
          undefined,
          optionsList
        );
        // setSelectedIds([]);
      } else {
        ids = isString(ids) || (ids.length == 0 && bit == 1 && reportSectionId!==7) ? allIds : ids;
        const idsWithoutAll = ids.filter(f => f != "All");
        if (idsWithoutAll.length == allIds.length) {
          reportSectionId !==7 && allIds.push("All");
          setSelectedIds({ ...selectedIds, [FilterKeyName]: allIds });
          onChangeFilter(
            FilterKeyName,
            allIds || [],
            FilterDataType,
            ids,
            undefined,
            undefined,
            optionsList
          );
        } else {
          setSelectedIds({ ...selectedIds, [FilterKeyName]: ids });
          onChangeFilter(
            FilterKeyName,
            ids || [],
            FilterDataType,
            id,
            undefined,
            undefined,
            optionsList
          );
        }
      }
    }
  }

  /**
   * render component  according to values
   * @param {*} obj
   * @param {*} index
   * @returns
   */
  function decideFilterComp(obj, index) {
    switch (obj.FilterDataType || "Text") {
      case "Text":
        return (
          <TextFieldWithToolTip
            key={obj.FilterKeyName + index}
            isForFilter
            id={obj.FilterKeyName}
            txtName={obj.FilterKeyName}
            disabled={false}
            value={inputValues?.[obj.FilterKeyName]}
            keyValue={""}
            onChange={e =>
              onChangeVal(obj.FilterKeyName, e.target, obj.FilterDataType)}
            isRequired={false}
            labelHeading={obj.FilterName}
            toolTip={""}
          />
        );
      case "MultiSelect":
        return (
          <>
            {obj.optionsList && obj.optionsList.length >= 0 && (
              <MultiSelectDD
                key={obj.FilterKeyName + index}
                minWidth={"300px"}
                header={obj.FilterName}
                className={"inline-filter"}
                optionsList={
                  obj.ShowLastValueInList == 1
                    ? sortBy(obj.optionsList, x => x.idValue)
                    : sortBy(obj.optionsList, x => x.value)
                }
                selectedIds={selectedIds[obj.FilterKeyName] || []}
                onChange={val =>
                  onMultiSelectDD(
                    val,
                    obj.optionsList,
                    obj.FilterKeyName,
                    obj.FilterDataType,
                    obj.optionsList.find(x => x.idValue != null).idValue,
                    (obj.optionsList[0].dependentFilter != null &&
                      obj.DependentFilter) ||
                      null,
                      null
                  )}
              />
            )}
          </>
        );

      case "DateRangeWeeklySlider": {
        const rangeDateArray = colFilteredObj
          .find(x => x.keyName === obj.FilterKeyName)
          ?.value?.split("-");

        const rangeDate = colFilteredObj
          .find(x => x.keyName === obj.FilterKeyName)
          ?.value?.split("-");

        const rangeStart =
          rangeDate?.length >= 1 && rangeDate[0] !== "NONE"
            ? rangeDate[0]
            : moment().format(standardDateFormat);
        const rangeEnd =
          rangeDateArray?.length >= 2
            ? rangeDate[1]
            : moment().format(standardDateFormat);
        return (
          <NullableSliderDatePicker
            key={obj.FilterKeyName + index}
            DatePickerOptional={obj.DatePickerOptional}
            clearFilterData={clearFilterData}
            isReporting
            isViewReport={false}
            sliderType={4}
            radioSlider={reportRadioRangeWeeklySlider}
            handelDateChangesSlideDate={(
              start,
              end,
              typeOfDate,
              QtrSelected
            ) => {
              handleNullableSliderDate(
                start,
                end,
                typeOfDate,
                QtrSelected,
                obj.FilterKeyName,
                obj.FilterDataType
              );
            }}
            qtrSelected={obj.qtrSelected}
            title={obj.FilterName}
            selectedDate={moment(rangeEnd).format(standardDateFormat)}
            selectedStartDate={rangeStart}
            selectedEndDate={rangeEnd}
            allCleared={allCleared}
            onError={onError}
          />
        );
      }
      case "DateRange": {
        const rangeDateArray = colFilteredObj
          .find(x => x.keyName === obj.FilterKeyName)
          ?.value?.split("-");

        const rangeDate = colFilteredObj
          .find(x => x.keyName === obj.FilterKeyName)
          ?.value?.split("-");

        const rangeStart =
          rangeDate?.length >= 1 && rangeDate[0] !== "NONE"
            ? rangeDate[0]
            : moment().format(standardDateFormat);
        const rangeEnd =
          rangeDateArray?.length >= 2
            ? rangeDate[1]
            : moment().format(standardDateFormat);
        return (
          <NullableSliderDatePicker
            key={obj.FilterKeyName + index}
            DatePickerOptional={obj.DatePickerOptional}
            clearFilterData={clearFilterData}
            isReporting
            isViewReport={false}
            sliderType={3}
            radioSlider={reportRadioRangeQTRSlider}
            handelDateChangesSlideDate={(
              start,
              end,
              typeOfDate,
              QtrSelected
            ) => {
              handleNullableSliderDate(
                start,
                end,
                typeOfDate,
                QtrSelected,
                obj.FilterKeyName,
                obj.FilterDataType
              );
            }}
            qtrSelected={obj.qtrSelected}
            title={obj.FilterName}
            selectedDate={moment(rangeEnd).format(standardDateFormat)}
            selectedStartDate={rangeStart}
            selectedEndDate={rangeEnd}
            allCleared={allCleared}
            onError={onError}
          />
        );
      }
      case "NullableDateRange": {
        const dateArray = colFilteredObj
          .find(x => x.keyName === obj.FilterKeyName)
          ?.value?.split("-");

        const startDate =
          dateArray?.length >= 1 && dateArray[0] !== "NONE"
            ? dateArray[0]
            : moment().format(standardDateFormat);
        const endDate =
          dateArray?.length >= 2
            ? dateArray[1]
            : moment().format(standardDateFormat);
        return (
          <NullableSliderDatePicker
            key={obj.FilterKeyName + index}
            DatePickerOptional={obj.DatePickerOptional}
            clearFilterData={clearFilterData}
            isReporting
            isViewReport={false}
            radioSlider={reportRadioSlider}
            sliderType={1}
            handelDateChangesSlideDate={(
              start,
              end,
              typeOfDate,
              QtrSelected
            ) => {
              handleNullableSliderDate(
                start,
                end,
                typeOfDate,
                QtrSelected,
                obj.FilterKeyName,
                obj.FilterDataType
              );
            }}
            title={obj.FilterName}
            selectedStartDate={startDate}
            selectedEndDate={endDate}
            selectedDate={moment(endDate).format(standardDateFormat)}
            onError={onError}
          />
        );
      }
      case "DateRangeSlider": {
        const rangeDateArray = colFilteredObj
          .find(x => x.keyName === obj.FilterKeyName)
          ?.value?.split("-");

        const rangeStartDate =
          rangeDateArray?.length >= 1 && rangeDateArray[0] !== "NONE"
            ? rangeDateArray[0]
            : moment().format(standardDateFormat);
        const rangeEndDate =
          rangeDateArray?.length >= 2
            ? rangeDateArray[1]
            : moment().format(standardDateFormat);
        return (
          <NullableSliderDatePicker
            key={obj.FilterKeyName + index}
            DatePickerOptional={obj.DatePickerOptional}
            clearFilterData={clearFilterData}
            isReporting
            isViewReport={false}
            sliderType={2}
            radioSlider={reportRadioRangeSlider}
            handelDateChangesSlideDate={(
              start,
              end,
              typeOfDate,
              QtrSelected
            ) => {
              handleNullableSliderDate(
                start,
                end,
                typeOfDate,
                QtrSelected,
                obj.FilterKeyName,
                obj.FilterDataType
              );
            }}
            title={obj.FilterName}
            selectedDate={moment(rangeEndDate).format(standardDateFormat)}
            selectedStartDate={rangeStartDate}
            selectedEndDate={rangeEndDate}
            onError={onError}
          />
        );
      }
      case "Autocomplete":
        return (
          <VirtualizedAutocomplete
            key={obj.FilterKeyName + index}
            parentKey={obj.FilterKeyName + index}
            allCleared={allCleared}
            dependentKey={dependentKey}
            reload={reload}
            clearFilterData={
              clearFilterData ||
              (
                obj?.optionsList?.filter(
                  option =>
                    (
                      colFilteredObj?.find(x => x.keyName === obj.FilterKeyName)
                        ?.value || []
                    ).find(selectedVal => selectedVal === option.id) !==
                    undefined
                ) || []
              ).length === 0
            }
            isSelectAll={false}
            header={obj.FilterName}
            optionsList={removeDuplicates(
              obj.ShowLastValueInList == 1
                ? sortBy(obj.optionsList, x => x.idValue)
                : sortBy(obj.optionsList, x => x.value),"value")}
            selectedIds={colFilteredObj.find(z=>z.keyName===obj.FilterKeyName)?.value || []}
            minWidth={"300px"}
            onChange={val =>
              onMultiSelectDD(
                val,
                obj.optionsList,
                obj.FilterKeyName,
                obj.FilterDataType,
                obj.optionsList.find(x => x.idValue != null).idValue,
                (obj.optionsList[0].dependentFilter != null &&
                  obj.DependentFilter) ||
                  null,
                reportSectionId!==7? 1 :0
              )}
              reportSectionId={reportSectionId}
          />
        );
    }
  }

  /**
   * call on slider
   * @param {*} start -> start date
   * @param {*} end -> end date
   * @param {*} typeOfDate -> type of slider
   * @param {*} qtrSelected -> quarter selection
   */
  const handleNullableSliderDate = (
    start,
    end,
    typeOfDate,
    qtrSelected,
    key,
    filterType
  ) => {
    if (typeOfDate == "NONE") {
      onChangeVal(key, "NONE", "NullableDateRange", typeOfDate);
    } else {
      const date = start + "-" + end;
      onChangeVal(key, date, filterType, typeOfDate, qtrSelected);
    }
  };

  return (
    <>
      <React.StrictMode>
        {isShowFilter ? (
          <>
            <div className={"row"} key={"report-breadCrumbs"}>
              <div className={"col-xs-12"}>
                <span className={"reports-breadcrumb"}>{"Filters :"}</span>
              </div>
            </div>
            <div
              className={"row bottom-xs"}
              style={{ padding: "0px 1px 5px 10px" }}
              key={"report-filters-row"}
            >
              {filterConfig.map((x, i) =>
                !x.isHideFilter &&
                x.FilterDataType !== "DateRange" &&
                x.FilterDataType !== "NullableDateRange" &&
                x.FilterDataType !== "DateRangeSlider" &&
                x.FilterDataType !== "DateRangeWeeklySlider" ? (
                  <div
                    key={"div" + x.FilterKeyName + i}
                    className={
                      x.FilterDataType == "DateRange" ||
                      x.FilterDataType == "NullableDateRange" ||
                      x.FilterDataType == "DateRangeSlider" ||
                      x.FilterDataType == "DateRangeWeeklySlider"
                        ? "col-xs-7  align-date-range"
                        : "col-xs-4 bottom-xs"
                    } //{"filterInput " + x.headerClass}
                    style={{
                      paddingLeft:
                        x.FilterDataType == "DateRange" ||
                        x.FilterDataType == "NullableDateRange" ||
                        x.FilterDataType == "DateRangeSlider" ||
                        x.FilterDataType == "DateRangeWeeklySlider"
                          ? "0px"
                          : null,
                      paddingRight: "5px",
                      paddingTop:
                        x.FilterDataType == "DateRange" ||
                        x.FilterDataType == "NullableDateRange" ||
                        x.FilterDataType == "DateRangeSlider" ||
                        x.FilterDataType == "DateRangeWeeklySlider"
                          ? "8px"
                          : "5px"
                    }} //paddingRight:"10px",
                  >
                    {decideFilterComp(x, i)}
                    <span key={"span" + i}> &nbsp;</span>
                  </div>
                ) : (
                  ""
                )
              )}
            </div>
            <div
              className={"row"}
              style={{ padding: "0px 1px 5px 10px" }}
              key={"report-date-filter-row"}
            >
              <div className={"row col-xs-12"} style={{ paddingLeft: "0px" }}>
                {filterConfig.map((x, i) =>
                  !x.isHideFilter &&
                  (x.FilterDataType == "DateRange" ||
                    x.FilterDataType == "NullableDateRange" ||
                    x.FilterDataType == "DateRangeSlider"  ||
                    x.FilterDataType == "DateRangeWeeklySlider") ? (
                    <div
                      key={"div" + x.FilterKeyName + i}
                      className={
                        x.FilterDataType == "DateRange" ||
                        x.FilterDataType == "NullableDateRange" ||
                        x.FilterDataType == "DateRangeWeeklySlider" ||
                        x.FilterDataType == "DateRangeSlider"
                          ? "col-xs-7  align-date-range"
                          : "col-x-5"
                      } //{"filterInput " + x.headerClass}
                      style={{
                        paddingLeft:
                          x.FilterDataType == "DateRange" ||
                          x.FilterDataType == "NullableDateRange" ||
                          x.FilterDataType == "DateRangeWeeklySlider" ||
                          x.FilterDataType == "DateRangeSlider"
                            ? "0px"
                            : null,
                        paddingRight: "5px",
                        paddingTop:
                          x.FilterDataType == "DateRange" ||
                          x.FilterDataType == "NullableDateRange" ||
                          x.FilterDataType == "DateRangeWeeklySlider" ||
                          x.FilterDataType == "DateRangeSlider"
                            ? "20px"
                            : "5px"
                      }} //paddingRight:"10px",
                    >
                      {decideFilterComp(x, i)}

                      <span key={"span" + x.FilterKeyName + i}> &nbsp;</span>
                    </div>
                  ) : (
                    ""
                  )
                )}
                <div
                  className={"col-xs-5 end-xs"}
                  style={{ marginTop: "52px" }}
                  key={"report-download-render-div"}
                >
                  {renderDownload()}
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </React.StrictMode>
    </>
  );
}
